import { message } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import DocumentsApi from '../../../api/Documents'
import LabourContracts from '../../../api/People/LabourContracts'
import { TimesheetsApi } from '../../../api/People/Timesheets'
import Timesheet from '../../../components/People/Timesheet/Timesheet'
import useSubmit from '../../../elements/Hooks/useSubmit'
import React, { useState } from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import _, { isEmpty, pick } from 'lodash'

const docsApi = new DocumentsApi()

function TimesheetCont() {
  const contractApi = new LabourContracts()
  const { data: list, fetching, fetch } = useFetch({ url: `timesheet/?select=*` })

  const {
    visible,
    modalType,
    object: timesheet,
    setObject: setTimesheet,
    submitting,
    approving,
    submit,
    approve,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
  } = useModalData(TimesheetsApi.create, TimesheetsApi.update, TimesheetsApi.remove, fetch)

  const [rates, setRates] = useState([])
  const [fetchingRates, setFetchingRates] = useState(false)

  const [contractData, setContractData] = useState(false)
  const onChangeContract = async (id) => {
    setFetchingRates(true)
    try {
      const contract = await contractApi.get(id.replace('labourContracts/', ''))
      setContractData(contract)
      setRates(_.get(contract, 'rates') || [])
      console.log('onChangeContract', _.get(contract, 'rates'))
    } catch (e) {
      console.error(e)
    }
    setFetchingRates(false)
  }

  const [orderDate, setOrderDate] = useState(false)
  const onChangeOrder = async (id) => {
    setFetchingRates(true)
    try {
      const key = id.replace('labours/', '')
      const order = await contractApi.workOrder.get(key)
      setOrderDate(order)
      order && setRates(_.get(order, 'rates'))
      console.log('onChangeOrder', _.get(order, 'rates'))
    } catch (e) {
      console.error(e)
    }
    setFetchingRates(false)
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('timesheet', timesheet.status),
    [timesheet.status, isEmpty(timesheet.status)]
  )
  const [submittingOperation, submitOperation] = useSubmit(TimesheetsApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    switch (operation) {
      case 'approve':
        {
          const TimesheetDB = await submitOperation({
            status: operation,
            ...pick(timesheet, ['_key', '_rev', '_id']),
          })
          if (TimesheetDB) setTimesheet(TimesheetDB)
        }
        break
      case 'submit':
        {
          const TimesheetDB = await submitOperation({
            status: operation,
            ...pick(timesheet, ['_key', '_rev', '_id']),
          })
          if (TimesheetDB) setTimesheet(TimesheetDB)
        }
        break
      default: {
        const TimesheetDB = await submitOperation({
          status: operation,
          ...pick(timesheet, ['_key', '_rev', '_id']),
        })
        if (TimesheetDB) {
          if (TimesheetDB) setTimesheet(TimesheetDB)
        }
      }
    }
    hide()
  }

  return (
    <Timesheet
      {...{
        list,
        fetching,
        submitting,
        approving,
        visible,
        fetch,
        timesheet,
        onShow,
        onCancel,
        submit,
        approve,
        removing,
        remove,
        update,
        modalType,
        formRef,
        onChangeContract,
        contractData,
        onChangeOrder,
        orderDate,
        rates,
        fetchingRates,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
      }}
    />
  )
}

export default TimesheetCont
